import React, { useMemo, useState, useCallback } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useFlag } from '../../../redux/flags/hooks/useFlag';
import { Url, URLS } from '@wix/da-url';
import BiLink from '../../../biLogger/Components/BiLink';
import { BiEventType } from '../../../biLogger/constants';
import PlainButtonOrLink from '../../../Button/PlainButtonOrLink';
import s from './ResponsiveMenuItems.scss';
function getMenuItemBiData(menuItem) {
    return {
        evid: BiEventType.TOP_NAV_CLICK,
        link_url: menuItem.url,
        link_name: menuItem.key,
        indicator: typeof menuItem.notification !== 'undefined'
            ? Number(menuItem.notification)
            : undefined,
    };
}
var ResponsiveMenuItems = function (_a) {
    var activeMainMenuItem = _a.activeMainMenuItem, watchCount = _a.watchCount, isLoggedIn = _a.isLoggedIn;
    var t = useTranslation().t;
    var _b = useState(false), isMoreMenuOpen = _b[0], setIsMoreMenuOpen = _b[1];
    var newHomePage = useFlag('cdc_new_homepage');
    var forceShowOldWatch = useFlag('cdc_show_old_watch');
    var swapWatchToFollow = useFlag('swap_watch_follow');
    var canShowWatch = !newHomePage || forceShowOldWatch;
    var toggleMoreMenu = useCallback(function () { return setIsMoreMenuOpen(function (isOpen) { return !isOpen; }); }, []);
    var menu = useMemo(function () { return [
        {
            key: 'browse',
            label: newHomePage ? 'siteHeader.home' : 'siteHeader.browse',
            url: Url.browseHomeLink(),
        },
        {
            key: 'watch',
            label: swapWatchToFollow ? 'siteHeader.following' : 'siteHeader.watch',
            notification: watchCount > 0,
            disabled: !canShowWatch || !isLoggedIn,
            url: Url.watchLink(),
        },
        {
            key: 'topics',
            label: 'siteHeader.topics',
            disabled: !newHomePage,
            url: Url.browseTopicsLink(),
        },
        {
            key: 'shop',
            label: 'siteHeader.shop',
            url: URLS.SHOP,
        },
        {
            key: 'groups',
            label: 'siteHeader.groups',
            url: URLS.GROUPS,
        },
        {
            key: 'forum',
            label: 'siteHeader.forum',
            url: URLS.FORUM,
        },
    ]; }, [canShowWatch, isLoggedIn, newHomePage, swapWatchToFollow, watchCount]);
    // note that there is an intentional overlap here - watch goes into the dropdown
    // in low resolutions, and is toggled in css
    var basicMenu = menu.slice(0, 2);
    var moreMenu = menu.slice(1, menu.length);
    return (React.createElement("div", { className: classnames(s['nav-list-container'], newHomePage && s['uplifted']) },
        React.createElement("ul", { className: s['nav-list'] },
            basicMenu.map(function (menuItem, index) {
                return !menuItem.disabled && (React.createElement("li", { key: menuItem.key, className: classnames(s['nav-list__item'], s["nav-list__item-" + menuItem.key]) },
                    React.createElement(BiLink, { biData: getMenuItemBiData(menuItem), className: classnames(s['nav-list__item__link'], menuItem.key === activeMainMenuItem && s['active'], menuItem.notification && s['notification']), href: menuItem.url }, t(menuItem.label))));
            }),
            React.createElement("li", { className: classnames(s['nav-list__item'], s['nav-list__item--more'], isMoreMenuOpen && s['nav-list__item--more-open']) },
                React.createElement(PlainButtonOrLink, { className: s['nav-list__item__link'], "aria-haspopup": "true", "aria-expanded": isMoreMenuOpen, "aria-controls": "site-header-more-menu", onClick: toggleMoreMenu }, t('siteHeader.more')),
                React.createElement("ul", { id: "site-header-more-menu", className: s['more-list'] }, moreMenu.map(function (menuItem) {
                    return !menuItem.disabled && (React.createElement("li", { key: menuItem.key, className: classnames(s['more-list__item'], s["more-list__item-" + menuItem.key], menuItem.notification && s['notification']) },
                        React.createElement(BiLink, { href: menuItem.url, biData: getMenuItemBiData(menuItem) }, t(menuItem.label))));
                }))))));
};
ResponsiveMenuItems.displayName = 'ResponsiveMenuItems';
export default ResponsiveMenuItems;
//# sourceMappingURL=ResponsiveMenuItems.js.map